/**
 * Tooltip
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

export default (() => {
  if (window.innerWidth < 992) return

  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  )

  /* eslint-disable no-unused-vars, no-undef */
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) =>
      new bootstrap.Tooltip(tooltipTriggerEl, {
        trigger: 'hover focus',
      })
  )
  /* eslint-enable no-unused-vars, no-undef */
})()
